import { Box, DialogContent, DialogTitle, Typography, useTheme } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import { ExperienceImagesSlider } from './experience-images-slider';
import { ExperienceModel } from '@/logic/services/experiences';
import { FormattedMessage } from 'react-intl';
import { pxToRem } from '@/theme/typography';
import shallow from 'zustand/shallow';
import { useDialog } from '@/logic/state/dialog';
import { CloseButton } from '../shared/close-button';

export const ExperienceInfoDialog: FC = () => {
  const theme = useTheme();
  const [dialog, setDialog] = useDialog(s => [s.dialog, s.setDialog], shallow);
  const [experience] = useState<ExperienceModel>(
    dialog?.experienceInfoDialogPayload as ExperienceModel
  );

  const handleCloseClick = (): void =>
    setDialog({
      wrapper: false,
      isExperienceInfoDialog: false,
      experienceInfoDialogPayload: null,
    });

  useEffect(() => {
    setDialog(prevState => ({
      ...prevState,
      minWidth: {
        minWidth: {
          mobile: '100%',
          tablet: '80%',
        },
      },
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box>
        <DialogTitle>
          <CloseButton handleClick={() => handleCloseClick()} />
        </DialogTitle>
        <DialogContent sx={{ padding: '0px !important' }}>
          <Box
            sx={{
              overflow: 'hidden',
            }}
          >
            <Typography
              component='h4'
              sx={{
                textAlign: 'center',
                fontWeight: 700,
                fontSize: { tablet: pxToRem(22), mobile: '18px' },
                mb: { tablet: pxToRem(32), mobile: '24px' },
                mt: { tablet: pxToRem(30), mobile: '24px' },
                color: theme.palette.grey[90],
                width: '100%',
              }}
            >
              {experience.name}
            </Typography>
            <ExperienceImagesSlider experience={experience} />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingInline: pxToRem(48),
              }}
            >
              <Typography
                sx={{
                  textAlign: 'start',
                  fontWeight: 700,
                  fontSize: { tablet: pxToRem(22), mobile: '18px' },
                  mb: { tablet: pxToRem(32), mobile: '16px' },
                  mt: { tablet: pxToRem(20), mobile: '24px' },
                  color: theme.palette.grey[90],
                  width: '100%',
                }}
              >
                <FormattedMessage id='experience_details.about' />
              </Typography>
              <Typography
                sx={{
                  textAlign: 'start',
                  fontWeight: 400,
                  fontSize: pxToRem(24),
                  mb: { tablet: pxToRem(70), mobile: '40px' },
                  mt: { tablet: pxToRem(26), mobile: '0px' },
                  color: theme.palette.grey[50],
                  width: { mobile: '100%', tablet: '70%' },
                }}
              >
                {experience.description}
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Box>
    </>
  );
};
